<template>
  <Modal
    :id="'cmp-b2b-change-password'"
    class="cmp-b2b-change_password"
    @cancelled="onCancel"
  >
    <template v-if="isResetPassword" slot="header">
      For a safe access, please create your own secure password</template
    >
    <template slot="body">
      <div v-if="isResetPassword" class="form-group">
        <div class="pw_validation">
          <span>Your password must contain the following:</span>
          <ul id="warn_container">
            <li>
              <img
                v-if="!validationResult.letter.valid"
                class="invalid_circle"
                src="static/icons/b2b/invalid_30_30.svg"
              />
              <img
                v-if="validationResult.letter.valid"
                class="valid_circle"
                src="static/icons/b2b/valid_30_30.svg"
              />
              At least <strong>one letter</strong>
            </li>
            <li>
              <img
                v-if="!validationResult.capital.valid"
                class="invalid_circle"
                src="static/icons/b2b/invalid_30_30.svg"
              />
              <img
                v-if="validationResult.capital.valid"
                class="valid_circle"
                src="static/icons/b2b/valid_30_30.svg"
              />
              At least <strong>one capital letter</strong>
            </li>
            <li>
              <img
                v-if="!validationResult.number.valid"
                class="invalid_circle"
                src="static/icons/b2b/invalid_30_30.svg"
              />
              <img
                v-if="validationResult.number.valid"
                class="valid_circle"
                src="static/icons/b2b/valid_30_30.svg"
              />
              At least <strong>one number</strong>
            </li>
            <li>
              <img
                v-if="!validationResult.space.valid"
                class="invalid_circle"
                src="static/icons/b2b/invalid_30_30.svg"
              />
              <img
                v-if="validationResult.space.valid"
                class="valid_circle"
                src="static/icons/b2b/valid_30_30.svg"
              />
              At least
              <strong>one [~,!,@,#,$,%,^,&,*,-,_,=,.,;,:,']</strong>
            </li>
            <li id="length" class="wrong">
              <img
                v-if="!validationResult.length.valid"
                class="invalid_circle"
                src="static/icons/b2b/invalid_30_30.svg"
              />
              <img
                v-if="validationResult.length.valid"
                class="valid_circle"
                src="static/icons/b2b/valid_30_30.svg"
              />
              At least <strong>8 characters</strong>
            </li>
          </ul>
        </div>
        <div class="field-content">
          <TextField
            :id="'password'"
            required
            :showValidationIcons="false"
            style="width: 100%"
            v-bind="textFieldConfig"
            :value="userModel.password"
            :placeholder="'new password'"
            :password="showEye"
            @validated="onValidation"
            @valuechanged="onTextFieldValueChange"
          ></TextField>
          <span @click="openEye" class="input-group-text">
            <i v-if="showEye" class="fas fa-eye"></i>
            <i v-if="!showEye" class="fas fa-eye-slash"></i>
          </span>
        </div>
      </div>
      <div class="reset-success" v-if="!isResetPassword">
        <span style="color: #0087ff" class="material-icons">
          check_circle
        </span>
        <span style="font-size: 100%; color: #0087ff"
          >Password changed successfully</span
        >
      </div>
    </template>

    <template v-if="isResetPassword" slot="options">
      <button @click.stop="onCancel" class="dt-button s6">
        {{ $t("detailsb2b_cancel") }}
      </button>
      <button
        :class="{ disabled: !isFormValid }"
        :disabled="!isFormValid"
        @click.stop="onSave"
        class="dt-button v1 with-ico s6"
      >
        <div class="button-text">Reset</div>
      </button>
    </template>
  </Modal>
</template>

<script>
import { B2BStoreNamespace as storeNS } from "../../store/index";
import { mapGetters } from "vuex";
import { AuthService } from "../../services/auth.service";
import Modal from "@dtplugins/modal/modal";
import {
  createTextFieldConfig,
  EventHooks,
} from "../../../../plugins/text-field";
import { f } from "vue-grid-layout";
export default {
  components: {
    Modal,
  },
  data() {
    return {
      textFieldConfig: createTextFieldConfig({
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: true,
        immediateValidation: true,
        validationEvent: EventHooks.OnKeyup,
      }),
      isResetPassword: true,
      showEye: true,
      validationResult: {
        capital: {
          valid: false,
          errors: ["error"],
        },
        letter: {
          valid: false,
          errors: ["error"],
        },
        number: {
          valid: false,
          errors: ["error"],
        },
        length: {
          valid: false,
          errors: ["error"],
        },
        space: {
          valid: false,
          errors: ["error"],
        },
      },
      userModel: {
        password: "",
        first_login: 0,
      },
    };
  },
  mounted() {},
  computed: {
    ...mapGetters(storeNS, {
      userDetails: "userDetails",
    }),
    isFormValid: function () {
      return Object.values(this.validationResult).every((e) => e.valid);
    },
  },
  methods: {
    validatePassword(value) {
      //validate the length
      if (value.length > 8) {
        this.onValidation("length", { valid: true, errors: [] });
      } else {
        this.onValidation("length", { valid: false, errors: ["error"] });
      }

      //validate letter
      if (value.match(/[A-z]/)) {
        this.onValidation("letter", { valid: true, errors: [] });
      } else {
        this.onValidation("letter", { valid: false, errors: ["error"] });
      }

      //validate capital letter
      if (value.match(/[A-Z]/)) {
        this.onValidation("capital", { valid: true, errors: [] });
      } else {
        this.onValidation("capital", { valid: false, errors: ["error"] });
      }

      //validate number
      if (value.match(/\d/)) {
        this.onValidation("number", { valid: true, errors: [] });
      } else {
        this.onValidation("number", { valid: false, errors: ["error"] });
      }

      //validate space
      if (value.match(/[^a-zA-Z0-9\-\/]/)) {
        this.onValidation("space", { valid: true, errors: [] });
      } else {
        this.onValidation("space", { valid: false, errors: ["error"] });
      }
    },

    onTextFieldValueChange: function (name, value) {
      this.userModel[name] = value;
      this.validatePassword(value);
    },
    onCancel: function () {
      this.$emit("cancelled", true);
    },
    onValidation: function (name, value) {
      this.$set(this.validationResult, name, value);
    },
    

    openEye() {
      this.showEye = !this.showEye;
    },
    async onSave(e) {
      const model = {
        ...this.userModel,
        external_user_id: this.userDetails.external_user_id,
      };
      AuthService.updatePassword(model).then((res) => {
        this.isResetPassword = false;

        setTimeout(() => {
          this.$emit("cancelled", true);
        }, 2000);
      });
    },
  },
};
</script>

<style  lang="scss" >
.cmp-b2b-change_password {
  .dt-input-box--container {
    --tf-webkit-box-shadow: none !important;
  }
  .reset-success {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .dt-modal--header {
    color: #e28303 !important;
  }
  .pw_validation {
    padding: 20px 0px;
    ul {
      list-style: none;
      padding: 5px 0px;
      li img {
        vertical-align: middle;
        padding: 0px 2px;
      }
    }
  }
  .field-content {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    justify-content: flex-start;
    .input-group-text {
      cursor: pointer;
    }
  }
  @media (min-width: 320px) and (max-width: 480px) {
    padding: 30px !important;
  }
}
</style>